//src/config
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions'; // ← NUEVO
import { getStorage } from 'firebase/storage';
const firebaseConfig = {
  apiKey: "AIzaSyChklFPJU8ElJDmo5yyN0sMrwPn0019Lmw",
  authDomain: "reactfacing.firebaseapp.com",
  projectId: "reactfacing",
  storageBucket: "reactfacing.firebasestorage.app",
  messagingSenderId: "372463292780",
  appId: "1:372463292780:web:4c70b7da4aadf42e34e349",
  measurementId: "G-GKMJY66Y4Z"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage= getStorage(app)
export const functions = getFunctions(app); // ← NUEVO